module.exports = __webpack_public_path__ + "img/photo-0020.3e91d04b.jpg";